import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorAddOrders = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M19.25 11V6A2.25 2.25 0 0 0 17 3.75H7A2.25 2.25 0 0 0 4.75 6v12A2.25 2.25 0 0 0 7 20.25h4a.75.75 0 0 1 0 1.5H7A3.75 3.75 0 0 1 3.25 18V6A3.75 3.75 0 0 1 7 2.25h10A3.75 3.75 0 0 1 20.75 6v5a.75.75 0 0 1-1.5 0Zm-2.4-3c0 .47-.38.85-.85.85H8a.85.85 0 0 1 0-1.7h8c.47 0 .85.38.85.85ZM13 12.694a.694.694 0 0 0 0-1.388H8a.694.694 0 1 0 0 1.388h5Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M17.75 13a.75.75 0 0 0-1.5 0v3.25H13a.75.75 0 0 0 0 1.5h3.25V21a.75.75 0 0 0 1.5 0v-3.25H21a.75.75 0 0 0 0-1.5h-3.25V13Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorAddOrders;
